export default "__VITE_ASSET__D5ue5tTL__"